import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinBy',
})
export class JoinByPipe implements PipeTransform {
  public transform(array: readonly unknown[] | null | undefined, separator = ', ', property?: string): string {
    if (!Array.isArray(array) || array.length === 0) {
      return '';
    }

    // Check if the array is of objects and a property name is provided
    const first = array[0];
    if (property && first && typeof first === 'object' && property in first) {
      return array.map((item) => (item as Record<string, unknown>)[property]).join(separator);
    }

    // Arrays of primitives; the generated DTOs carry ids as numbers.
    if (typeof array[0] === 'string' || typeof array[0] === 'number') {
      return array.join(separator);
    }

    return '';
  }
}
